import { cmsConflictIndicationShown } from '@wix/bi-logger-cms-data/v2'
import type {
  EditorSDK,
  I18n,
  Logger,
} from '@wix/wix-data-client-common-standalone'
import type { CollectionsApi } from '@wix/wix-code-collections-api'
import type { PageRef } from '@wix/editor-platform-sdk-types'
import { getDPCollectionId } from './utils/getDPCollectionId'
import { fetchRouterDatasetFromPage } from '../business-logic/dynamic-pages/fetchRouterDatasetFromPage'

export const openDpVariantsRemoveConnectionsWarning = async ({
  logger,
  editorSdkProxy,
  i18n,
  collectionsApi,
  pageRef,
}: {
  logger: Logger
  editorSdkProxy: EditorSDK
  i18n: I18n
  collectionsApi: CollectionsApi
  pageRef: PageRef
}) => {
  editorSdkProxy.editor.openConfirmationPanel({
    headerText: i18n.t(
      'Dynamic_Pages_Remove_Connections_Variants_Warning_Title',
    ),
    descriptionText: i18n.t(
      'Dynamic_Pages_Remove_Connections_Variants_Warning_Description',
    ),
    mainActionText: i18n.t(
      'Dynamic_Pages_Remove_Connections_Variants_Warning_Button_Text',
    ),
    shouldShowIllustration: false,
  })

  const routerRef = await editorSdkProxy.document.routers.getByPage({
    pageRef,
  })

  const collectionId = await getDPCollectionId({
    editorSdkProxy,
    routerRef,
    pageRef,
  })

  const collection = collectionId
    ? await collectionsApi.get(collectionId)
    : undefined

  const routerDataset = await fetchRouterDatasetFromPage(
    editorSdkProxy,
    pageRef,
  )

  logger.bi(
    cmsConflictIndicationShown({
      conflictType: 'variant_page_connections',
      collection_id: collection?.id,
      collection_name: collection?.displayName,
      environment: 'EDITOR',
      componentType: 'notification_banner',
      ctaName: 'remove_variant',
      ds_id: routerDataset?.ref?.id,
      ds_name: routerDataset?.data?.displayName,
      element_id: pageRef.id,
    }),
  )
}
